import ProductMainCard from "./ProductMainCard";
import ProductFactorSection from "./ProductFactorSection";
import {apiGetProductAccountCard, apiGetProductCard} from "api/reportApi";
import {useDispatch, useSelector} from "react-redux";
import {Grid} from "@mui/material";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import {useEffect, useState} from "react";
import {apiProductsList} from "api/productApi";
import {apiGetProjects} from "api/projectApi";
import {useSearchParams} from "react-router-dom";
import {setQueryParam} from "helpers/queryParam";
import useDateState from "helpers/useDateState";
import {useAppDispatch, useAppSelector} from "store/store";

interface Props {
    tab?: string;
    options?: any;
    onChange?: (state: any) => void;
}

interface FD {
    productId?: number | string | null;
    projectId?: number;
    tab?: string;
    search?: any;
    sort?: any;
}

const ProductAccountCardComponent = (props: Props) => {
    const {options, onChange} = props;
    const dispatch: any = useAppDispatch();
    const [searchParams] = useSearchParams();
    const store = useAppSelector((x: any) => x);
    const {token} = store.businessReducer.business;
    const {toDate, fromDate, setDates} = useDateState();
    const {product: prd} = store.reportReducer;
    const {products}: ProductReducer = store.productReducer;
    const {projects} = store.projectReducer;
    const pagination = store.paginationReducer;
    const [formData, setFormData] = useState<FD>({
        tab: props.tab,
        ...options,
        productId: searchParams.get("productId"),
    });
    const [product, setProduct] = useState<any>({});
    const {productId, projectId, tab, search, sort} = formData;

    // useEffect(() => {
    //   dispatch(apiProductsList(token));
    //   dispatch(apiGetProjects(token));
    // }, [token]);

    useEffect(() => setFormData((x) => ({...x, tab: props.tab})), [props.tab]);
    useEffect(() => setFormData((x) => ({...x, ...options})), [options]);
    useEffect(
        () => onChange && onChange({product, dates: {fromDate, toDate}}),
        [product, toDate, fromDate]
    );
    useEffect(() => submit(), [formData, toDate, fromDate]);
    useEffect(() => {
        let pid = 0;
        if (productId && typeof productId === "string") pid = parseInt(productId);
        if (productId && typeof productId === "number") pid = productId;
        prd && pid === prd.id && setProduct(prd);
    }, [productId, prd]);

    useEffect(() => {
        submit();
    }, [pagination]);

    function submit() {
        let {search, sort} = pagination;
        let params: any = {productId};
        let data: any = {};
        if (projectId) params.projectId = projectId;
        if (fromDate && toDate) {
            data.column = "date";
            data.columnType = "date";
            data.primarySearch = fromDate;
            data.secondarySearch = toDate;
            data.filterType = "7";
        }
        dispatch(apiGetProductAccountCard({pagination, search, sort, token, options: data, params, tab}));
    }

    return (
        <>
            <Grid container spacing={4} style={{justifyContent: "space-between", marginBottom: "20px"}}>
                {product && (
                    <>
                        <Grid item xs={12} md={7}>
                            <div className="flex w-full items-center gap-6 h-28 md:h-14 flex-wrap md:flex-nowrap mb-6">
                                <div className="md:min-w-[230px]">
                                    <BasicDateInput
                                        range
                                        placeholder="کل سال مالی"
                                        onChange={(dates) => setDates(dates)}
                                        defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                                    />
                                </div>
                                <div className="w-full">
                                    <BasicSelect
                                        key={productId}
                                        options={products || []}
                                        placeholder={(product && product.label) || "کالا/خدمت"}
                                        defaultValue={typeof productId === "string" ? parseInt(productId) : productId}
                                        onChange={(val) => {
                                            setQueryParam("productId", val);
                                            setFormData((x) => ({...x, productId: val}));
                                        }}
                                        withSearch
                                        withRefresh
                                        refreshList={() => dispatch(apiProductsList({token}))}
                                    />
                                </div>
                            </div>
                            <ProductMainCard data={product}/>
                        </Grid>
                        <Grid item xs={12} md={5} className="md:mt-20">
                            <ProductFactorSection data={product}/>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
};

export default ProductAccountCardComponent;
